// @ts-strict-ignore
import { IBaseArticleProjectProcessor } from './i-base-article-project.processor';
import { IsProjectType } from '@project/model/is-project-type';
import { McsArticleProjectProcessor } from './mcs-article-project.processor';
import { MountingRailArticleProjectProcessor } from './mounting-rail-article-project.processor';
import { Injectable } from '@angular/core';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { MountingRailHelper } from '@project/helper/mounting-rail.helper';
import { ProjectModel } from '@project/model/project.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ArticleAccessoryManager } from '../manager/article-accessory.manager';
import { InsertArticleService } from '@project/components/article/service/insert-article.service';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectArticleService } from '@project/service/project-article.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { LabelingUtils } from '@3d-scene/model3d/util/labeling-utils';
import { ArticleService } from '../service/article.service';
import { ProjectType } from '@project/model/project-type';

@Injectable({ providedIn: 'root' })
export class BaseArticleProjectProcessorFactory {
  constructor(
    private projectModel: ProjectModel,
    private projectModelService: ProjectModelService,
    private projectArticleService: ProjectArticleService,
    private mountingRailHelper: MountingRailHelper,
    private selectionModel: SelectionModel,
    private selectionModelService: SelectionModelService,
    private articleAccessoryManager: ArticleAccessoryManager,
    private localeResourceManager: LocaleResourceManager,
    private alertHelper: AlertHelper,
    private connectionInfoUtils: ConnectionInfoUtils,
    private labelingUtils: LabelingUtils,
    private _insertArticleService: InsertArticleService,
    private articleService: ArticleService
  ) {}

  public createBaseArticleManagerByProjectType(projectType: ProjectType, notificationMessage: string): IBaseArticleProjectProcessor {
    if (IsProjectType.mcs(projectType)) {
      return new McsArticleProjectProcessor(
        notificationMessage,
        this.projectModel,
        this.projectModelService,
        this.projectArticleService,
        this.mountingRailHelper,
        this.selectionModel,
          this.selectionModelService,
        this.articleAccessoryManager,
        this.localeResourceManager,
        this.connectionInfoUtils,
        this.labelingUtils,
        this.alertHelper,
        this._insertArticleService,
        this.articleService
      );
    }
    if (IsProjectType.mounting(projectType)) {
      return new MountingRailArticleProjectProcessor(
        notificationMessage,
        this.projectModel,
        this.projectModelService,
        this.projectArticleService,
        this.mountingRailHelper,
        this.selectionModel,
          this.selectionModelService,
        this.articleAccessoryManager,
        this.localeResourceManager,
        this.connectionInfoUtils,
        this.labelingUtils,
        this.alertHelper,
        this._insertArticleService,
        this.articleService
      );
    }
    return null;
  }
}
